<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="assetSignedStudents"
  >
    <div class="align-items-baseline display-flex-row m-filters-and-actions">
      <form
        autocomplete="off"
        class="align-items-baseline m-form-row m-simple-filter"
        name="simple-filters-form"
        @submit.prevent="searchSimpleFilter"
      >
        <AtomSelectPrimary
          v-model.number="simpleFilter.estado"
          :disabled="pagination.showLoadingState"
          :elements="estados"
          keyField="id"
          name="tipo_estado"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />

        <AtomInputPrimary
          v-model="simpleFilter.integrante"
          :disabled="pagination.showLoadingState"
          name="email"
          placeholder="alumno@email.com"
          type="email"
          wrapperClass="a-input-wrapper-row"
          @input="searchSimpleFilter"
        />

        <AtomInputPrimary
          v-model="simpleFilter.nombre_familia"
          :disabled="pagination.showLoadingState"
          name="nombre_familia"
          placeholder="Equipo"
          type="text"
          wrapperClass="a-input-wrapper-row"
          @input="searchSimpleFilter"
        />

        <AtomButtonSecondary
          :button-secondary="buttonSecondary.reload"
          :disabled="pagination.showLoadingState"
          @reloadListing="reloadListing"
        />
      </form>

      <AtomButtonSecondary
        :button-secondary="buttonSecondary.create"
        :disabled="!element.publicado"
        @showModal="$modal.showModal"
      />

      <form
        autocomplete="off"
        class="m-form-row margin-left-auto"
        name="download-csv-form"
        @submit.prevent="readFamiliasExportar"
      >
        <AtomButtonPrimary
          :button-primary="buttonPrimary"
          :disabled="pagination.showLoadingState || !familiaInscriptos.length"
        />
      </form>
    </div>

    <div class="m-table-primary">
      <table class="table-layout-fixed">
        <tr v-show="familiaInscriptos.length">
          <th
            class="text-align-left"
            width="34%"
          >
            {{ $t('mEditionMapEnrollmentsFamilies.table.thFamily') }}
          </th>
          <th
            class="text-align-center"
            width="20%"
          >
            {{ $t('mEditionMapEnrollmentsFamilies.table.thEdit') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionMapEnrollmentsFamilies.table.thAdd') }}
          </th>
           <th
            class="text-align-center"
            width="10%"
          >
            {{ $t('mEditionMapEnrollmentsFamilies.table.thShow') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionMapEnrollmentsFamilies.table.thStars') }}
          </th>
           <th
            class="text-align-center"
            width="10%"
          >
            {{ $t('mEditionMapEnrollmentsFamilies.table.thActive') }}
          </th>
        </tr>
        <tr
          v-for="familia in familiaInscriptos"
          :key="familia.id"
          class="row-data"
        >
          <td class="text-align-left">
            <span class="display-flex-row-center">
              <AtomAvatarSecondary
                avatar-class="medium"
                :user-image="familia.logo"
              />
              <span class="display-flex-column user-info">
                <span class="ellipsis">
                  {{ familia.nombre }}
                </span>
                <small :class="familia.activa ? 'ellipsis font-weight-regular text-color-success'
                : 'ellipsis font-weight-regular text-color-danger'">
                  {{ familia.integrantes ? familia.integrantes : 0 }} integrantes
                </small>
              </span>
            </span>
          </td>
          <td class="text-align-center">
            <AtomButtonSecondary
              :button-secondary="buttonIconRounded.edit"
              :element="familia"
              :disabled="!familia.activa"
              @showModal="$modal.showModal"
            />
          </td>
          <td class="text-align-center">
            <AtomButtonSecondary
              :button-secondary="buttonIconRounded.add"
              :element="familia"
              :disabled="!familia.activa"
              @showModal="$modal.showModal"
            />
          </td>
          <td class="text-align-center">
           <AtomButtonSecondary
              :button-secondary="buttonIconRounded.show"
              :element="familia"
              method="goToFamily"
              @goToFamily="goToFamily"
            />
          </td>
          <td class="text-align-center">
            <span>
              {{ familia.puntos }}
              <i class="fas fa-star text-color-notifications-primary"></i>
            </span>
          </td>
          <td class="text-align-center">
            <AtomTogglePrimary
              v-model="familia.activa"
              :disabled="requests.updateFamiliaEstado.isRequested"
              :element-id="familia.id"
              method="updateFamiliaEstado"
              name="activo"
              :show-loading="requests.updateFamiliaEstado.isRequested &&
                requests.updateFamiliaEstado.itemLoading === familia.id"
              sliderClass="a-toggle-slider-maps-primary"
              type="checkbox"
              @updateFamiliaEstado="updateFamiliaEstado"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import { validateEmail } from '@/plugins/validation/validators'

export default {
  name: 'MoleculeEditionMapEnrollmentsFamilies',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  props: {
    element: Object,
    elementCategorias: Array
  },

  data () {
    return {
      familiaInscriptos: [],

      buttonIconRounded: {
        add: {
          class: 'a-button-secondary a-button-maps-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionMapEnrollmentsFamiliesModalAdd',
          icon: 'far fa-user-plus',
          method: 'showModal',
          text: '',
          tooltip: this.$t('mEditionMapEnrollmentsFamilies.tooltip.add'),
          type: 'button'
        },

        edit: {
          class: 'a-button-secondary a-button-maps-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionMapEnrollmentsFamiliesModalEdit',
          icon: 'far fa-pencil-alt',
          method: 'showModal',
          text: '',
          tooltip: this.$t('mEditionMapEnrollmentsFamilies.tooltip.edit'),
          type: 'button'
        },

        show: {
          class: 'a-button-secondary a-button-maps-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionMapEnrollmentsFamilyMembers',
          icon: 'far fa-file-alt',
          method: 'goToFamily',
          text: '',
          tooltip: this.$t('mEditionMapEnrollmentsFamilies.tooltip.show'),
          type: 'button'
        }
      },

      buttonPrimary: {
        action: this.$t('mEditionMapEnrollmentsFamilies.buttonPrimary'),
        behavior: 'download',
        class: 'a-button-maps-primary',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        create: {
          class: 'a-button-secondary a-button-maps-secondary',
          component: 'MoleculeEditionMapEnrollmentsFamiliesModalCreate',
          icon: 'fas fa-plus',
          method: 'showModal',
          text: this.$t('mEditionMapEnrollmentsFamilies.buttonSecondary.createText'),
          type: 'button'
        },

        reload: {
          class: 'a-button-secondary a-button-maps-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-sync-alt',
          method: 'reloadListing',
          text: '',
          tooltip: this.$t('mEditionMapEnrollmentsFamilies.tooltip.reload'),
          type: 'button'
        }
      },

      estados: [
        {
          id: '',
          name: 'Todos los estados'
        },
        {
          id: 1,
          name: 'Activas'
        },
        {
          id: 0,
          name: 'Inactivas'
        }
      ],

      filter: {
        estado: '',
        fecha_creacion: '',
        integrante: '',
        limite: 10,
        nombre_familia: '',
        pagina: 1
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      },

      requests: {
        createAcademiaActorResetPassword: {
          itemLoading: '',
          isRequested: false
        },

        updateFamiliaEstado: {
          itemLoading: '',
          isRequested: false
        }
      },

      showLoadingState: true,

      simpleFilter: {
        estado: '',
        integrante: '',
        nombre_familia: ''
      }
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    updatedData () {
      this.showLoadingState = true
      this.readInscripcionesProyecto()
    }
  },

  created () {
    this.readInscripcionesProyecto()
  },

  methods: {
    createAcademiaActorResetPassword (actorId) {
      if (!this.requests.createAcademiaActorResetPassword.isRequested) {
        this.requests.createAcademiaActorResetPassword.isRequested = true
        this.requests.createAcademiaActorResetPassword.itemLoading = actorId
        this.$services.create('academia', 'createAcademiaActorResetPassword', {}, [this.$store.getters.getAcademyData.id, actorId])
          .then(response => {
            this.$alerts.pushAlert('mEditionMapEnrollmentsFamilies', 'createAcademiaActorResetPassword', 'success')
            this.requests.createAcademiaActorResetPassword.isRequested = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionMapEnrollmentsFamilies', 'createAcademiaActorResetPassword', 'error', 'a-alert-danger')
            this.requests.createAcademiaActorResetPassword.isRequested = false
          })
      }
    },

    goToFamily (component, element) {
      this.$store.commit('setAssetSelectedFamily', element)
      this.$router.push(`/${this.$t('rPaths.map')}/${this.$route.params.id}/${this.$t('mEditionMenu.map.enrollments.subject')}/${element.id}/${this.$t('mEditionMenu.map.enrollments.children.familyMembers.subedition')}`)
    },

    gotToSignedStudentContents (alumno) {
      this.$store.commit('setAssetSelectedStudent', alumno)
      this.$router.push(`/${this.$t('rPaths.asset')}/${this.$route.params.id}/${this.$t('mEditionMenu.asset.signedStudents.subject')}/${alumno.id}/${this.$t('mEditionMenu.asset.signedStudents.children.contents.subedition')}`)
    },

    readInscripcionesProyecto () {
      if (!this.pagination.showLoadingState) {
        this.pagination.showLoadingState = true
        this.$services.read('familia', 'readFamilias', {}, [this.$route.params.id], this.filter)
          .then(response => {
            this.familiaInscriptos = []
            this.familiaInscriptos = response.data.familias
            this.pagination.currentQuantity = this.familiaInscriptos.length
            this.pagination.totalPages = response.data.pages
            this.pagination.totalQuantity = response.data.total
            this.pagination.showLoadingState = false
            this.showLoadingState = false
          })
          .catch(error => {
            console.log(error)
            this.familiaInscriptos = []
            this.pagination.currentQuantity = 0
            this.pagination.totalPages = 0
            this.pagination.totalQuantity = 0
            this.pagination.showLoadingState = false
            this.showLoadingState = false
          })
      }
    },

    readFamiliasExportar () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.read('familia', 'readFamiliasExportar', {}, [this.element.id], this.filter)
          .then(response => {
            this.$files.downloadCsv(response.data, `${this.$t('mEditionMapEnrollmentsFamilies.files.family')}-${this.$moment().format('YYYYMMDD')}`)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionMapEnrollmentsFamilies', 'readFamiliasExportar', 'success')
          })
          .catch(error => {
            console.log(error)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionMapEnrollmentsFamilies', 'readFamiliasExportar', 'error', 'a-alert-danger')
          })
      }
    },

    reloadListing () {
      this.resetSimpleFilter()
      this.resetAdvancedFilter()
      this.setPaginationCurrentPage(1)
    },

    resetAdvancedFilter () {
      this.filter = {
        estado: '',
        fecha_creacion: '',
        integrante: '',
        limite: 10,
        nombre_familia: '',
        pagina: 1
      }
    },

    resetSimpleFilter () {
      this.simpleFilter = {
        estado: '',
        integrante: '',
        nombre_familia: ''
      }
    },

    searchAdvancedFilter (advancedFilter) {
      this.resetSimpleFilter()
      this.filter = Object.assign({}, advancedFilter)
      this.setPaginationCurrentPage(1)
    },

    searchSimpleFilter () {
      if (validateEmail(this.simpleFilter.integrante) ||
        this.simpleFilter.integrante === '') {
        this.resetAdvancedFilter()
        this.filter.estado = this.simpleFilter.estado
        this.filter.nombre_familia = this.simpleFilter.nombre_familia
        this.filter.integrante = this.simpleFilter.integrante
        this.setPaginationCurrentPage(1)
      }
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readInscripcionesProyecto()
    },

    updateFamiliaEstado (element) {
      if (!this.requests.updateFamiliaEstado.isRequested) {
        this.requests.updateFamiliaEstado.isRequested = true
        this.requests.updateFamiliaEstado.itemLoading = element.id
        this.$services.update('familia', 'updateFamiliaEstado', { activa: element.state }, [element.id])
          .then(response => {
            this.$alerts.pushAlert('mEditionMapEnrollmentsFamilies', 'updateFamiliaEstado', response.data.activa ? 'activationSuccess' : 'deactivationSuccess')
            this.requests.updateFamiliaEstado.isRequested = false
          })
          .catch(error => {
            console.log(error)
            this.familiaInscriptos[this.familiaInscriptos.findIndex(familia => familia.id === element.id)].activa = +!element.state
            this.$alerts.pushAlert('mEditionMapEnrollmentsFamilies', 'updateFamiliaEstado', 'error', 'a-alert-danger')
            this.requests.updateFamiliaEstado.isRequested = false
          })
      }
    }
  }
}
</script>
